import { render, staticRenderFns } from "./ChangeMailFormReception.vue?vue&type=template&id=da630b0e&scoped=true&lang=pug"
import script from "./ChangeMailFormReception.vue?vue&type=script&lang=js"
export * from "./ChangeMailFormReception.vue?vue&type=script&lang=js"
import style0 from "./ChangeMailFormReception.vue?vue&type=style&index=0&id=da630b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da630b0e",
  null
  
)

export default component.exports